import Link from 'next/link'
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination"

const LearnPagination = ({ currentPage, totalPages, baseUrl }) => {
  if (totalPages <= 1) return null

  const generatePageNumbers = () => {
    const pages = []
    const showEllipsis = totalPages > 7

    if (!showEllipsis) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      // Show ellipsis logic for more than 7 pages
      if (currentPage <= 4) {
        // Near the beginning
        pages.push(1, 2, 3, 4, 5, '...', totalPages)
      } else if (currentPage >= totalPages - 3) {
        // Near the end
        pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
      } else {
        // In the middle
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages)
      }
    }

    return pages
  }

  const getPageUrl = (page) => {
    if (page === 1) return baseUrl
    return `${baseUrl}?page=${page}`
  }

  return (
    <div className="mt-8">
      <Pagination>
        <PaginationContent>
          {/* Previous button */}
          <PaginationItem>
            {currentPage > 1 ? (
              <Link href={getPageUrl(currentPage - 1)} passHref legacyBehavior>
                <PaginationPrevious />
              </Link>
            ) : (
              <PaginationPrevious className="pointer-events-none opacity-50" />
            )}
          </PaginationItem>

          {/* Page numbers */}
          {generatePageNumbers().map((page, index) => {
            if (page === '...') {
              return (
                <PaginationItem key={`ellipsis-before-${generatePageNumbers()[index + 1] || 'end'}`}>
                  <PaginationEllipsis />
                </PaginationItem>
              )
            }

            const isActive = page === currentPage

            return (
              <PaginationItem key={page}>
                <Link href={getPageUrl(page)} passHref legacyBehavior>
                  <PaginationLink isActive={isActive}>
                    {page}
                  </PaginationLink>
                </Link>
              </PaginationItem>
            )
          })}

          {/* Next button */}
          <PaginationItem>
            {currentPage < totalPages ? (
              <Link href={getPageUrl(currentPage + 1)} passHref legacyBehavior>
                <PaginationNext />
              </Link>
            ) : (
              <PaginationNext className="pointer-events-none opacity-50" />
            )}
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  )
}

export default LearnPagination